import { Globe2 } from "lucide-react";
import { useState } from "react";

import { faviconUrlForOrigin } from "~/lib/favicon";

/**
 * A page's site icon, from Amoreg's own favicon route, else a globe (no
 * usable address, a private host, or an icon that failed to load). Used by
 * the right panel's tabs and the cloud browser's own tab strip.
 */
export function PreviewFavicon({ url }: { url: string | null }) {
  const faviconUrl = faviconUrlForOrigin(url);
  const [failedUrl, setFailedUrl] = useState<string | null>(null);
  if (!faviconUrl || failedUrl === faviconUrl) return <Globe2 className="size-3 shrink-0" aria-hidden />;
  return (
    <img
      src={faviconUrl}
      alt=""
      aria-hidden
      draggable={false}
      referrerPolicy="no-referrer"
      className="size-3 shrink-0 rounded-sm"
      onError={() => setFailedUrl(faviconUrl)}
    />
  );
}
